module.exports = __webpack_public_path__ + "img/intro_video_text_top.42d34e15.png";